// extracted by mini-css-extract-plugin
export default {"card":"DescriptiveBentoCard_card__HTL5I","cardImg":"DescriptiveBentoCard_cardImg__PhK6E","cardInfo":"DescriptiveBentoCard_cardInfo__oUsfU"};